var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "about-prize" }, [
    _c(
      "div",
      { staticClass: "about-prize__wrapper" },
      [
        _c("BaseTitle", {
          staticClass: "about-prize__title",
          attrs: { text: _vm.titleText, tag: "h2" }
        }),
        _c("AppSlider", { attrs: { items: _vm.prizes } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47cf1306", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47cf1306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AboutPrizeBlock.vue
// module id = UOp+
// module chunks = 2